<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    :label="$t('number')"
                    :value="form.number_f"
                    background-color="white" 
                    hide-details="auto"
                    dense
                    disabled
                    outlined
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <p-status :state="form.state"></p-status>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    :label="$t('entry_date')" 
                    background-color="white" 
                    hide-details="auto" 
                    dense 
                    outlined
                    :value="form.date"
                    readonly
                    append-icon="mdi-calendar">
                </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <PDatePicker
                    :label="$t('document_date')"
                    outlined
                    :rules="[isRequired]"
                    :readonly="!mode.edit"
                    :max="form.date"
                    background-color="white" 
                    v-model="form.document_date"
                    hide/>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                    :label="$t('reference')"
                    v-model="form.reference"
                    :rules="[isRequired]"
                    :readonly="!mode.edit"
                    background-color="white" 
                    hide-details="auto" 
                    dense outlined>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row v-if="(multiWarehouse == false || multiAccount == false || multiDimension == false)">
            <!-- <v-col cols="12" md="3" v-if="!multiWarehouse">
                <v-autocomplete
                    label="Warehouse"
                    v-model="globalWarehouseId"
                    :rules="[isRequired]"
                    :readonly="!mode.edit"
                    outlined
                    dense
                    background-color="white"
                    hide-details="auto"
                    item-text="display_name"
                    :items="warehouses"
                    item-value="id"
                    ></v-autocomplete>
            </v-col> -->
            <v-col cols="12" md="3" v-if="!multiAccount">
                <v-autocomplete
                    label="Account"
                    v-model="globalAccountId"
                    :rules="[isRequired]"
                    :readonly="!mode.edit"
                    :items="userAccounts"
                    outlined
                    dense
                    background-color="white"
                    hide-details="auto"
                    item-text="display_name"
                    item-value="id"
                    @change="handleAccountChange"
                    ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" v-if="!multiDimension">
                <v-autocomplete
                    label="Dimension"
                    v-model="globalDimensionId"
                    :readonly="!mode.edit"
                    outlined
                    dense
                    background-color="white"
                    hide-details="auto"
                    item-text="name"
                    item-value="id"
                    @change="handleDimensionChange"
                    :items="dimensions"
                    >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div v-for="(line, index) in form.lines" :key="line.key">
                    <StockJournalLines
                        v-model="form.lines[index]"
                        :multi-account="multiAccount"
                        :multi-warehouse="multiWarehouse"
                        :multi-dimension="multiDimension"
                        :unit-value-editable="unitValueEditable"
                        :document-date="form.document_date"
                        @delete-row="deleteRow"
                        :mode="mode"
                        />
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-btn block depressed small @click="addRow">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    {{$t("add_new_line")}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <v-textarea
                    :label="$t('remarks')"
                    v-model="form.remarks"
                    :rules="[isRequired]"
                    :readonly="!mode.edit"
                    background-color="white"
                    outlined
                    hide-details="auto"
                    rows="4"
                    @change="handleRemarkChange"
                    >
                </v-textarea>
            </v-col>
            <v-col cols="12" md="4">
                <v-textarea
                    :label="$t('journal_remarks')"
                    v-model="form.journal_remarks"
                    :readonly="!mode.edit"
                    :rules="[isRequired]"
                    background-color="white"
                    outlined
                    hide-details="auto"
                    rows="4"
                    >
                </v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import { clone } from 'lodash';

import StockJournalLines from "./StockJournalLines.vue";
import PDatePicker from "./../common/PDatePicker.vue";
import PStatus from './../common/PStatus';

import { hasMulti, pluckAndUniqOne, randomSix } from '../../utils/toolkit';
import { isRequired, isNumeric } from './../../utils/validations';
import { createStockJournal, deleteStockJournal, getIdempotentKey, getStockJournalByNumber, updateStockJournal, postStockJournal } from './../../services/stockJournal'

export default {
    components: { 
        StockJournalLines, 
        PDatePicker, 
        PStatus
    },
    name: "StockJournal",
    props: {
        type: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            isRequired,
            isNumeric,
            requestId: null,
            globalToggleModeAuto: false,
            form: {
                id: null,
                type_id: null,
                number_f: this.numberPlaceholder,
                reference: null,
                remarks: null,
                journal_remarks: null,
                date: moment().format("YYYY-MM-DD"),
                document_date: moment().format("YYYY-MM-DD"),
                lines: [],
            },
            line: {
                item_id: null,
                warehouse_id: null,
                quantity: null,
                measure_unit_id: null,
                unit_value: null,
                value: null,
                account_id: null,
                dimension_id: null,
            },
            multiWarehouse: false,
            multiAccount: false,
            multiDimension: true,
            mode: {
                edit: true,
            },
            globalWarehouseId: null,
            globalAccountId: null,
            globalDimensionId: null,
            loading: {
                idempotentKey: false,
                submit: false,
                data: false,
                search: false,
                overlay: false
            },
            unitValueEditable: false
        };
    },
    computed: {
        ...mapState("accounting", ["baseCurrency"]),
        ...mapGetters({
            warehouses: "stockJournal/warehouse/warehouses",
            userWarehouses: "stockJournal/warehouse/userWarehouses",
            accounts: "stockJournal/account/accounts",
            userAccounts: "stockJournal/account/userAccounts",
            dimensions: "stockJournal/dimension/dimensions"
        }),
    },
    watch: {
        "form.lines": {
            handler() {
                if(this.multiAccount == false) this.populateLineAccountsFromGlobal();
                if(this.multiWarehouse == false) this.populateLineWarehousesFromGlobal(this.globalWarehouseId);
                if(this.multiDimension == false) this.populateLineDimensionsFromGlobal();
            },
            deep: true
        },
        mode: {
            handler() {
                this.$emit("mode", this.mode);
            },
            deep: true
        },
        loading: {
            handler(loading) {
                this.$emit("loading", loading);
            },
            deep: true
        },
        form: {
            handler(value) {
                this.$emit("change", value);
            },
            deep: true
        },
        globalWarehouseId(value) {
            this.populateLineWarehousesFromGlobal(value)
        }
    },
    methods: {
        addRow() {
            this.form.lines.push({ ...this.line, warehouse_id: this.globalWarehouseId, key: randomSix() });
        },
        setType() {
            this.form.type = this.type;
        },
        setPlaceholder() {
            switch(this.type) {
                case "GOODS_RECEIPT":
                    this.form.number_f = "GRN - - - - - - -";
                    break;
                case "GOODS_ISSUE":
                    this.form.number_f = "GIV - - - - - - -";
                    break;
                case "STOCK_ADJUSTMENT":
                    this.form.number_f = "ADJ - - - - - - -";
                    break;
                default:
                    this.form.number_f = "NA"
                    break;
            }
        },
        reset() {
            this.resetForm();
            this.addRow();
            this.resetGlobals();
            this.mode.edit = true;
            this.$refs.form.resetValidation();
        },
        resetForm() {
            this.form = {
                id: null,
                type_id: 1,
                number_f: null,
                reference: null,
                remarks: null,
                state: "NEW",
                journal_remarks: null,
                date: moment().format("YYYY-MM-DD"),
                document_date: moment().format("YYYY-MM-DD"),
                lines: []
            }
            this.setPlaceholder();
            this.setType();
        },
        resetGlobals() {
            this.globalAccountId = null;
            this.globalDimensionId = null;
        },
        deleteRow(key) {
            this.form.lines = this.form.lines.filter((line) => line.key !== key);
        },
        handleAccountChange() {
            this.populateLineAccountsFromGlobal();
        },
        // handleWarehouseChange(value) {
        //     this.populateLineWarehousesFromGlobal(value);
        // },
        handleDimensionChange() {
            this.populateLineDimensionsFromGlobal();
        },
        handleRemarkChange() {
            this.copyRemarksToJournalRemarks();
        },
        populateLineAccountsFromGlobal() {
            this.form.lines.map(each => each.account_id = this.globalAccountId);
        },
        populateLineWarehousesFromGlobal(value) {
            console.log("POPULATED WAREHOUSE", value)
            this.form.lines.map(each => each.warehouse_id = value);
        },
        populateLineDimensionsFromGlobal() {
            this.form.lines.map(each => each.dimension_id = this.globalDimensionId);
        },
        copyRemarksToJournalRemarks() {
            if(this.form.journal_remarks == null || this.form.journal_remarks == "") this.form.journal_remarks = this.form.remarks;
        },
        async submit() {
            if(this.$refs.form.validate() === false) return;
            try {
                this.loading.overlay = true;
                if(this.form.id === null || this.form.id === "") {
                    let resp = await createStockJournal(this.form, this.requestId);
                    this.form = clone(resp.data.record, true);
                    this.setType();
                    this.$emit("success", resp.data.message);
                } else {
                    let resp = await updateStockJournal(this.form);
                    this.form = clone(resp.data.record, true);
                    this.setType();
                    this.$emit("success", resp.data.message)
                }
                this.mode.edit = false;
                this.loading.overlay = false;
            } catch (error) {
                this.loading.overlay = false;
                if(error.response) this.$emit("error", error.response.data.message)
                else this.$emit("error", error);
            }
        },
        async delete() {
            try {
                this.loading.overlay = true;
                let resp = await deleteStockJournal(this.form.id);
                this.$emit("success", resp.data.message)
                this.loading.overlay = false;
                this.reset();
            } catch (error) {
                this.loading.overlay = false;
                if(error.response) this.$emit("error", error.response.data.message)
                else this.$emit("error", error);
            }
        },
        async post() {
            try {
                this.loading.overlay = true;
                if(!this.requestId) await this.fetchIdempotentKey();
                let resp = await postStockJournal(this.form.id, this.requestId);
                this.form = clone(resp.data.record, true);
                this.$emit("success", resp.data.message);
                this.loading.overlay = false;
                // setInterval(this.reload, 3000);
            } catch (error) {
                this.loading.overlay = false;
                if(error.response) this.$emit("error", error.response.data.message)
                else this.$emit("error", error);
            }
        },
        // reload() {
        //     this.fetchStockJournalByNumber({number: this.form.number, type: this.type})
        // },
        async fetchIdempotentKey() {
            this.loading.idempotentKey = true;
            let response = await getIdempotentKey();
            this.requestId = response.data.key;
            this.loading.idempotentKey = false;
        },
        async fetchStockJournalByNumber({number, type}) {
            try {
                this.loading.overlay = true;
                let resp = await getStockJournalByNumber({number, type});
                this.reset();
                this.form = resp.data;
                this.setType();
                this.mode.edit = false;
                this.autoSetGlobals();
                this.globalToggleModeAuto ? this.autoToggleMulti() : this.manualToggleMulti();
                this.loading.overlay = false;
            } catch (error) {
                this.loading.overlay = false;
                this.reset();
                if(error.response) this.$emit("error", error.response.data.message)
                else this.$emit("error", error);
            }
        },
        autoToggleMulti() {
            this.multiWarehouse = hasMulti("warehouse_id", this.form.lines);
            this.multiAccount = hasMulti("account_id", this.form.lines);
            this.multiDimension = hasMulti("dimension_id", this.form.lines);
        },
        manualToggleMulti() {
            switch(this.type) {
                case "GOODS_RECEIPT":
                    this.multiWarehouse = false;
                    this.multiAccount = false;
                    this.multiDimension = false;
                    this.unitValueEditable = true;
                    break;
                case "GOODS_ISSUE":
                    this.multiWarehouse = false;
                    this.multiAccount = true;
                    this.multiDimension = true;
                    this.unitValueEditable = false;
                    break;
                case "STOCK_ADJUSTMENT":
                    this.multiWarehouse = true;
                    this.multiAccount = true;
                    this.multiDimension = true;
                    this.unitValueEditable = true;
                    break;
                default:
                    this.multiWarehouse = true;
                    this.multiAccount = true;
                    this.multiDimension = true;
                    break;
            }
        },
        autoSetGlobals() {
            if(!this.multiWarehouse) this.globalWarehouseId = pluckAndUniqOne("warehouse_id", this.form.lines);
            if(!this.multiAccount) this.globalAccountId = pluckAndUniqOne("account_id", this.form.lines);
            if(!this.multiDimension) this.globalDimensionId = pluckAndUniqOne("dimension_id", this.form.lines);
        },
        activateEditMode() {
            this.mode.edit = true;
        }
    },
    created() {
        this.globalWarehouseId = this.$route.params.warehouseId;
        this.fetchIdempotentKey();
        this.$emit("mode", this.mode);
        this.$emit("change", this.form);
        this.manualToggleMulti();
        this.setPlaceholder();
        this.setType();
        this.addRow();
    },
    destroyed() {
        // clearInterval(this.reload);
    }
};
</script>

<style></style>
